import './bubbles.scss';

const bubbleElements = $('.js-bubbles .bubbles__item');

if (bubbleElements.length) {
    let previousInteger = null;

    setInterval(() => {
        let randomInteger;

        do {
            randomInteger = Math.floor(Math.random() * bubbleElements.length);
        } while (randomInteger === previousInteger);

        previousInteger = randomInteger;

        const randomBubble = bubbleElements.eq(randomInteger);

        randomBubble.addClass('is-animating');
        setTimeout(() => {
            randomBubble.removeClass('is-animating');
        }, 2100);
    }, 1300);
}
